var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27778 14C7.27778 13.4477 7.70062 13 8.22222 13C8.74382 13 9.16667 13.4477 9.16667 14C9.16667 14.5523 8.74382 15 8.22222 15C7.70062 15 7.27778 14.5523 7.27778 14Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C11.4784 13 11.0556 13.4477 11.0556 14C11.0556 14.5523 11.4784 15 12 15C12.5216 15 12.9444 14.5523 12.9444 14C12.9444 13.4477 12.5216 13 12 13Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8333 14C14.8333 13.4477 15.2562 13 15.7778 13C16.2994 13 16.7222 13.4477 16.7222 14C16.7222 14.5523 16.2994 15 15.7778 15C15.2562 15 14.8333 14.5523 14.8333 14Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22222 3C8.74382 3 9.16667 3.44772 9.16667 4V5H14.8333V4C14.8333 3.44772 15.2562 3 15.7778 3C16.2994 3 16.7222 3.44772 16.7222 4V5H19.5556C20.0772 5 20.5 5.44772 20.5 6V20C20.5 20.5523 20.0772 21 19.5556 21H4.44444C3.92284 21 3.5 20.5523 3.5 20V6C3.5 5.44772 3.92284 5 4.44444 5H7.27778V4C7.27778 3.44772 7.70062 3 8.22222 3ZM5.38889 11V19H18.6111V11H5.38889ZM18.6111 9H5.38889V7H18.6111V9Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.534c64ad889f7d6fe844d81c4b6ef43a.svg";
export { ForwardRef as ReactComponent };